import styled from "styled-components";
import { space, SpaceProps } from "styled-system";

import { ReactComponent as SearchIcon } from "./search.svg";

const StyledDiv = styled.div<SpaceProps>`
  display: flex;
  align-items: center;
  ${space}
`;

export default function SearchIconRegular({ ...props }: SpaceProps) {
  return (
    <StyledDiv {...props}>
      <SearchIcon></SearchIcon>
    </StyledDiv>
  );
}
